import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IUserLoginData } from '../../../../shared/interfaces/user.interface';
import { NotificationService } from '../../../../shared/services/notification.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private fb = inject(FormBuilder);
  private authenticationService = inject(AuthenticationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  notificationService = inject(NotificationService);

  loginForm = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  });

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.authenticationService
        .login(this.loginForm.value as IUserLoginData)
        .then((valid: boolean) => {
          if (valid) {
            const returnUrl =
              this.route.snapshot.queryParams['returnUrl'] || '/';

            if (returnUrl) {
              this.router.navigateByUrl(returnUrl);
            } else {
              this.router.navigateByUrl('/');
            }
          }
        });
    }
  }
}
